import React, { useEffect, useState } from "react";
import style from "./ticker.module.css";
import PageHeader from "../../../components/pageHeader/pageHeader";
import Table, { tableCustomStyles } from "../../../components/CommonComponents/Table/Table";
import axios from "axios";
import { ErrorToast, SuccessToast } from "../../../components/toastMessage";
import Modal from "react-bootstrap/Modal";
import { useDebounce } from "../../../hooks/common";
import Paginator, { PaginatorForRDT } from "../../../components/CommonComponents/Paginator/Paginator";
import Dropdown from 'react-bootstrap/Dropdown';
import DropdownButton from 'react-bootstrap/DropdownButton';
import { BASE_URL } from "../../../constants/Constants";
import Edit from "../../../assets/EditInWhite.svg";
import BoxComponent from "../../../components/CommonComponents/BoxComponent/BoxComponent";
import { group } from "console";
import { useNavigate } from "react-router-dom";
import Tooltip from 'react-bootstrap/Tooltip';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import DataTable, { TableColumn } from 'react-data-table-component';
import { Form, Row, Col } from 'react-bootstrap';
import EditButton, { ViewButton } from "../../../components/CommonComponents/EditComponent/EditComponent";
import { _axios } from "../../../utils/axios";
import { cookieUtils } from "../../../utils/cookieUtils";

interface TickerItem {
  srNo: number;
  itemName: string;
  date: string;
  second_date: string;
  status: string;
}

interface row {
  srNo: number;
  itemName: string;
  date: string;
  second_date: string;
  status: string;
}

const ticker = () => {
  const [isGridView, setIsGridView] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [showAddModal, setAddShowModal] = useState(false);
  const [selectedItem, setSelectedItem] = useState<TickerItem | null>(null);
  const [selectedAddItem, setSelectedAddItem] = useState<TickerItem | null>(
    null
  );
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [tickerList, setTickerList] = useState<Array<any>>([]);
  const [lgShow, setLgShow] = useState(false);
  const [editShow, setEditShow] = useState(false);
  const [totalList, setTotalList] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);
  const [entriesPerPage, setEntriesPerPage] = useState(10);
  const [searchQuery, setSearchQuery] = useState("");
  const search = useDebounce(searchQuery);
  const [sortByStartDate, setSortByStartDate] = useState<boolean>(false);
  const [sortBy, setSortBy] = useState<string | null>(null);
  const [showDropdown, setShowDropdown] = useState(false);
  const [startDate, setStartDate] = useState<string | null>(null);
  const [endDate, setEndDate] = useState<string | null>(null);
  const [btwStartDate, setBtwStartDate] = useState<string | null>(null);
  const [btwEndDate, setBtwEndDate] = useState<string | null>(null);
  const [activeStatus, setActiveStatus] = useState(false);
  const [inactiveStatus, setInactiveStatus] = useState(false);
  const navigate = useNavigate();

  const isUserLogin = async () => {
    // const userDetails = await localStorage.getItem('userDetails');
    // if (userDetails === null) {
    //   navigate('/onboarding/login');
    // }
    const userDetails = cookieUtils.getSecureCookie('userDetails');
    if (!userDetails) {
      navigate('/onboarding/login');
    }
  }

  useEffect(() => {
    isUserLogin();
  }, [navigate]);

  const formatDate = (dateString: any) => {
    if (!dateString) return '';
    const options: Intl.DateTimeFormatOptions = { day: '2-digit', month: '2-digit', year: 'numeric' };
    return new Date(dateString).toLocaleDateString('en-GB', options);
  };

  const [tickerData, setTickerData] = useState({
    srNo: "",
    itemName: "",
    date: "",
    second_date: "",
    status: "",
  });

  const handleAddClick = () => {
    resetTickerData();
    setLgShow(true);
  };

  const resetTickerData = () => {
    setTickerData({
      srNo: "",
      itemName: "",
      date: "",
      second_date: "",
      status: "",
    });
  };

  const addTicker = async () => {
    try {
      const response = await _axios.post(
        `${BASE_URL}/api/ticker/add`,
        {
          itemName: tickerData.itemName,
          date: tickerData.date,
          second_date: tickerData.second_date,
          status: tickerData.status === "Active" ? 1 : 0,
        }
      );

      const data = response.data;
      console.log(data);
      getTickerList();

      SuccessToast('Ticker added successfully');
      window.location.reload();

    } catch (error) {
      console.error("Error adding ticker:", error);
    }
  };

  const handleEditClick = (item: any) => {
    console.log("Edit button clicked:", item);
    const data = {
      srNo: item.ticker_id,
      itemName: item.text_details,
      date: item.start_date,
      second_date: item.end_date,
      status: item.status == 1 ? "Active" : "Inactive",
    };

    setSelectedItem(data);
    setTickerData(data);
    setShowModal(true);
  };

  const editTicker = async (tickerId: any) => {
    console.log("tickerData", selectedItem);

    try {
      if (selectedItem) {
        // const response = await fetch(`${BASE_URL}/api/ticker/edit`, {
        //   method: "PATCH",
        //   headers: {
        //     "Content-Type": "application/json",
        //   },
        //   body: JSON.stringify({
        //     id: selectedItem.srNo,
        //     itemName: selectedItem.itemName,
        //     date: selectedItem.date,
        //     second_date: selectedItem.second_date,
        //     status: selectedItem.status === "Active" ? 1 : 0,
        //   }),
        // });
        const response = await _axios.patch(`${BASE_URL}/api/ticker/edit`, {
          id: selectedItem.srNo,
          itemName: selectedItem.itemName,
          date: selectedItem.date,
          second_date: selectedItem.second_date,
          status: selectedItem.status === "Active" ? 1 : 0,
        });

        // const data = await response.json();
        const data = response.data;
        SuccessToast('Ticker edited successfully');
        console.log("Backend Response:", data);

        setTimeout(function () {
          window.location.reload();
        }, 1200);


        getTickerList();
      }
    } catch (error) {
      console.error(`Error editing ticker with ID ${tickerId}:`, error);
    }
  };

  const handleModalClose = () => {
    setShowModal(false);
    setSelectedItem(null);
    // window.location.reload();
  };

  const handleModalAddClose = () => {
    setAddShowModal(false);
    setSelectedAddItem(null);
  };

  const handleUpdateClick = () => {
    handleModalClose();
  };

  const handleUpdateClickAdd = () => {
    handleModalAddClose();
  };

  const [row, setRow] = useState();

  const columns: TableColumn<any>[] = [
    {
      name: "Sr. No.",
      // selector: (row: any, rowIndex: number | undefined) =>
      //   (currentPage - 1) * entriesPerPage + (rowIndex ?? 0) + 1,
      selector: (log: any, rowIndex: number | undefined) => {
        const serialNumber = (currentPage - 1) * entriesPerPage + (rowIndex ?? 0) + 1;
        return serialNumber.toString().padStart(3, '0');
      },
      width: '100px',
      sortable: false,
      grow: 0.5,
    },
    {
      name: "Text Details",
      selector: (row: any) => row.text_details || "-",
      sortable: true,
      sortFunction: (a: any, b: any) => {
        const aValue = a.text_details || "";
        const bValue = b.text_details || "";
        return aValue.localeCompare(bValue);
      },
      cell: (row: any) => (
        <span className="text-center">{row.text_details || "-"}</span>
      ),
      center: true,
      grow: 3,

    },
    {
      name: "Start Date",
      width: "182px",
      selector: (row: any) => formatDate(row.start_date ?? ''),
      sortable: true,
      grow: 2,
      sortFunction: (a: any, b: any) => {
        const dateA = new Date(a.start_date);
        const dateB = new Date(b.start_date);
        if (dateA.getFullYear() !== dateB.getFullYear()) {
          return dateA.getFullYear() - dateB.getFullYear();
        }
        if (dateA.getMonth() !== dateB.getMonth()) {
          return dateA.getMonth() - dateB.getMonth();
        }
        return dateA.getDate() - dateB.getDate();
      },
    },
    {
      name: "End Date",
      width: "182px",
      selector: (row: any) => formatDate(row.end_date ?? ''),
      sortable: true,
      grow: 2,
      sortFunction: (a: any, b: any) => {
        const dateA = new Date(a.end_date);
        const dateB = new Date(b.end_date);
        if (dateA.getFullYear() !== dateB.getFullYear()) {
          return dateA.getFullYear() - dateB.getFullYear();
        }
        if (dateA.getMonth() !== dateB.getMonth()) {
          return dateA.getMonth() - dateB.getMonth();
        }
        return dateA.getDate() - dateB.getDate();
      },
    },
    {
      name: "Status",
      width: "120px",
      cell: (row: any) => (
        <button
          className={
            row.status == 1 ? "activeButtonCss" : "inactiveButtonCss"
          }
        >
          {row.status == 1 ? "Active" : "Inactive"}
        </button>
      ),
      selector: (row: any) => row.status,
      sortable: true,
    }, {
      name: 'Created By',
      selector: (row: any) => row.created_by,
      cell: (row: any) => <span className="text-center">{row.created_by}</span>,
      sortable: true,
      width: "170px",
    },
    {
      name: 'Created On',
      selector: (row: any) => formatDate(new Date(row.created_on)),
      sortable: true,
      width: "170px",
    },
    {
      name: 'Modified By',
      selector: (row: any) => row.modified_by,
      cell: (row: any) => <span className="text-center">{row.modified_by}</span>,
      sortable: true,
      width: "170px",
    },
    {
      name: 'Modified On',
      selector: (row: any) => formatDate(new Date(row.modified_on)),
      sortable: true,
      width: "170px",
    },
    {
      name: "Action",
      width: "100px",
      cell: (row: any) => (
        // <img
        //   src={Edit}
        //   alt="Edit"
        //   onClick={() => handleEditClick(row)}
        //   className="globalEditCss"
        // />
        <div className="flex space-x-2">
          <EditButton
            onClick={() => handleEditClick(row)}
          />
          <ViewButton
            disabled={true}
            onClick={function (): void {
              throw new Error("Function not implemented.");
            }}
          />
        </div>
      ),
      sortable: false,
      grow: 1,

    },
  ];

  const indexedTickerList = tickerList.map((item, index) => ({
    ...item,
    index: (currentPage - 1) * entriesPerPage + index + 1
  }));


  useEffect(() => {
    getTickerList();
  }, [currentPage, search, startDate, endDate, btwStartDate, btwEndDate, activeStatus, inactiveStatus]);


  const getTickerList = () => {
    const apiUrl = `${BASE_URL}/api/ticker/list`;

    let statusFilter = null;

    if (activeStatus && !inactiveStatus) {
      statusFilter = 1;
    } else if (!activeStatus && inactiveStatus) {
      statusFilter = 0;
    }

    const requestData = {
      page: currentPage,
      limit: entriesPerPage,
      search: search,
      startDate,
      endDate,
      btwStartDate,
      btwEndDate,
      status: activeStatus ? 1 : (inactiveStatus ? 0 : null)
    };

    console.log("Sending API request:");
    console.log("URL:", apiUrl);
    console.log("Request Body:", requestData);

    _axios
      .post(apiUrl, requestData)
      .then(function (response) {
        if (response?.data?.success === 0) {
          ErrorToast(response?.data?.message);
          return;
        }
        setTotalList(response.data.data.total_rows);
        setTickerList([...response.data.data.results]);
      })
      .catch(function (error) {
        console.log(error);
      });
  };

  const handlePageChange = (page: React.SetStateAction<number>) => {
    setCurrentPage(page);
  };


  const handleDateFilterChange = (type: string, date: string) => {
    if (type === 'afterStartDate') {
      setStartDate(date);
    } else if (type === 'beforeEndDate') {
      setEndDate(date);
    }

    getTickerList();
  };

  const betDateFilterChange = (type: string, date: string) => {
    if (type === 'btwStartDate') {
      setBtwStartDate(date);
    } else if (type === 'btwEndDate') {
      setBtwEndDate(date);
    }
    getTickerList();
  };

  const handleStatusChange = (status: string) => {
    if (status === "active") {
      setActiveStatus(!activeStatus);
      if (!activeStatus && inactiveStatus) {
        setInactiveStatus(false);
      }
    } else if (status === "inactive") {
      setInactiveStatus(!inactiveStatus);
      if (!inactiveStatus && activeStatus) {
        setActiveStatus(false);
      }
    }
    // getTickerList();
  };

  const dropdownContent = (
    <div className={style.dropdownBox}>
      <ul>
        <Dropdown.Menu show className="align-left">
          <div className={style.dropContent}>
            <Dropdown.Header className={style.DropHeader}>Ticker Upload filter</Dropdown.Header>
            <div className={style.dropdownCheck}>
              <input
                type="checkbox"
                className={style.checkBoxDrop}
                checked={activeStatus}
                onChange={() => handleStatusChange("active")}
              />
              <label className={style.DropLabel}>Active Status</label>
            </div>
            <div className={style.dropdownCheck}>
              <input
                type="checkbox"
                className={style.checkBoxDrop}
                checked={inactiveStatus}
                onChange={() => handleStatusChange("inactive")}
              />
              <label className={style.DropLabel}>Inactive Status</label>
            </div>
            {/* <div className={style.dropdownContent}>
              <input
                type="date" placeholder="\u00A0"
                className={style.dropdownOption}
                onChange={(event) => handleDateFilterChange("afterStartDate", event.target.value)}
              />
              <label className={style.DropLabel}>After Start Date</label>
            </div>
            <div className={style.dropdownContent}>
              <input
                type="date" placeholder="\u00A0"
                className={style.dropdownOption}
                onChange={(event) => handleDateFilterChange("beforeEndDate", event.target.value)}
              />
              <label className={style.DropLabel}>Before End Date </label>
            </div>
            <div className={style.dropdownContent}>
              <input
                type="date"
                placeholder="Between start date"
                className={style.dropdownOptionBtw}
                onChange={(event) => betDateFilterChange("btwStartDate", event.target.value)}
              />
              <input
                type="date"
                placeholder="Between end date"
                className={style.dropdownOptionBtw}
                onChange={(event) => betDateFilterChange("btwEndDate", event.target.value)}
              />
              <label className={style.DropLabel}>Date Interval </label>
              <br />
            </div> */}
          </div>
        </Dropdown.Menu>
      </ul>
    </div>
  );

  return (
    <div>
      <div className={style.bodyBox}>
        <PageHeader
          title="Ticker Upload"
          searchQuery={searchQuery}
          setSearchQuery={setSearchQuery}
          showSearchButton={true}
          showAdditionalButton={true}
          buttonTitle="Add Ticker"
          onClick={() => setLgShow(true)}
          isGridView={isGridView}
          onGridIconClick={() => setIsGridView(!isGridView)}
          showFilterButton={true}
          dropdownContent={dropdownContent}
        ></PageHeader>

        {isGridView ? (
          <>
            <BoxComponent>
              <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-3">
                {tickerList
                  ?.filter((row: any) =>
                    row.text_details
                      .toLowerCase()
                      .includes(searchQuery.toLowerCase())
                  )
                  .map((row: any) => (
                    <div className="p-4 rounded-2xl bg-white flex flex-col shadow-lg border border-gray-300" key={row.srNo}>
                      <div className="flex justify-between items-center space-x-4 mb-4">
                        <button className={row.status === 1 ? "activeButtonCss" : "inactiveButtonCss"}>
                          {row.status === 1 ? "Active" : "Inactive"}
                        </button>
                        <div className="flex justify-center space-x-1">
                          {/* <img src={Edit} alt="Edit" onClick={() => handleEditClick(row)} className="globalEditCss" /> */}
                          <EditButton
                            onClick={() => handleEditClick(row)}
                          />
                          <ViewButton
                            disabled={true}
                            onClick={function (): void {
                              throw new Error("Function not implemented.");
                            }}
                          />
                        </div>
                      </div>
                      <div className="mb-2 flex">
                        <p className="font-bold text-base w-1/2">Text Details</p>
                        <p className="text-base mx-2">:</p>
                        <p className="text-base w-2/3">{row?.text_details}</p>
                      </div>
                      <div className="mb-2 flex">
                        <p className="font-bold text-base w-1/2">Start Date</p>
                        <p className="text-base mx-2">:</p>
                        <p className="text-base w-2/3">{formatDate(row?.start_date ?? '-')}</p>
                      </div>
                      <div className="mb-2 flex">
                        <p className="font-bold text-base w-1/2">End Date</p>
                        <p className="text-base mx-2">:</p>
                        <p className="text-base w-2/3">{formatDate(row?.end_date ?? '-')}</p>
                      </div>
                    </div>
                  ))}
              </div>
              <Paginator
                limit={entriesPerPage}
                page={currentPage}
                setPage={handlePageChange} // Update page state when page changes
                count={totalList || 0}
              />
            </BoxComponent>
          </>
        ) : (
          <BoxComponent>
            <Table
              columns={columns}
              data={indexedTickerList}
              paginationTotalRows={totalList || 0}
              onChangePage={(p) => handlePageChange(p)} // Update page state when page changes
              customStyles={tableCustomStyles}
              paginationComponent={PaginatorForRDT}
            />
          </BoxComponent>
        )}

        {/* Add Modal */}
        <>
          <Modal
            size="lg"
            show={lgShow}
            onHide={() => setLgShow(false)}
            aria-labelledby="example-modal-sizes-title-vcenter-lg"
            centered
          >
            <div className={style.modalPd}>
              <Modal.Header className="p-8">
                <div style={{ width: "100%" }}>
                  <h5 className={style.popUpHeading}>Ticker Upload</h5>
                </div>
              </Modal.Header>

              <Modal.Body className="p-10">
                <div className="position-relative">
                  <label className={style.subHeadingLabel}>Ticker Text </label>
                  <textarea
                    placeholder="Enter Ticker here"
                    value={tickerData.itemName}
                    onChange={(e) =>
                      setTickerData({ ...tickerData, itemName: e.target.value })
                    }
                    className={style.textBoxArea}
                  ></textarea>
                </div>

                <div className={style.dateContainer}>
                  <div className={`${style.dateItem}  ${style.dateInput}`}>
                    <label className={style.boldLable}>Start Date</label>
                    <input
                      type="date"
                      value={tickerData.date}
                      onChange={(e) =>
                        setTickerData({ ...tickerData, date: e.target.value })
                      }
                      className="p-2"
                    />
                  </div>
                  <div className={`${style.dateItem}  ${style.dateInput}`}>
                    <label className={style.boldLable}>End Date</label>
                    <input
                      type="date"
                      value={tickerData.second_date}
                      onChange={(e) =>
                        setTickerData({
                          ...tickerData,
                          second_date: e.target.value,
                        })
                      }
                      className="p-2"
                    />
                  </div>
                </div>
                {/* Toggle button */}
                <div className="position-relative mt-10">
                  <div className={style.footerActive}>
                    <label className={style.footerActive}>Activate Ticker</label>
                    <label className={style.toggleBtn}>
                      <input
                        type="checkbox"
                        checked={tickerData.status === "Active"}
                        className={style.inputCheckbox}
                        onChange={(e) =>
                          setTickerData({
                            ...tickerData,
                            status: e.target.checked ? "Active" : "Inactive",
                          })
                        }
                      />
                      <span className={style.slider}></span>
                    </label>
                  </div>
                </div>

                <div className={style.buttonSection}>
                  <button
                    // className={style.publishButton}
                    className="buttonCss"
                    onClick={() => {
                      addTicker();
                      handleUpdateClickAdd();
                    }}
                  >
                    Publish
                  </button>
                  <button
                    // className={style.closeButton}
                    className="closeButtonCss"
                    onClick={() => {
                      setLgShow(false);
                      resetTickerData();
                    }}
                  >
                    Close
                  </button>
                </div>
              </Modal.Body>
            </div>
          </Modal>
        </>

        {showModal && selectedItem && (
          <>
            <Modal
              size="lg"
              show={true}
              aria-labelledby="example-modal-sizes-title-vcenter-lg"
              centered
              className={`${style.modalBox} rounded-50`}
            >
              <div className={style.modalPd}>
                <Modal.Header>
                  <div style={{ width: "100%" }}>
                    <h5 className={`${style.popUpHeading} p-5`}> Edit Ticker</h5>
                  </div>
                </Modal.Header>

                <Modal.Body className="m-8">
                  <div className="position-relative">
                    <label className={style.subHeadingLabel}>Ticker text </label>
                    <textarea
                      className={style.textBoxArea}
                      placeholder="Enter Office Address"
                      value={selectedItem.itemName}
                      onChange={(e) => {
                        if (selectedItem) {
                          setSelectedItem({
                            ...selectedItem,
                            itemName: e.target.value,
                          });
                        }
                      }}
                      required
                    ></textarea>
                  </div>
                  <div className={style.dateContainer}>
                    <div className={`${style.dateItem}  ${style.dateInput}`}>
                      <label className={style.boldLable}>Start Date</label>
                      <input
                        type="date"
                        value={selectedItem.date}
                        onChange={(e) => {
                          if (selectedItem) {
                            setSelectedItem({
                              ...selectedItem,
                              date: e.target.value,
                            });
                          }
                        }}
                        className="p-2"
                      />
                    </div>

                    <div className={`${style.dateItem}  ${style.dateInput}`}>
                      <label className={style.boldLable}>End Date</label>
                      <input
                        type="date"
                        value={selectedItem.second_date}
                        onChange={(e) => {
                          if (selectedItem) {
                            setSelectedItem({
                              ...selectedItem,
                              second_date: e.target.value,
                            });
                          }
                        }}
                        className="p-2"
                      />
                    </div>

                  </div>
                  <div className="position-relative mt-10">
                    <div className={style.footerActive}>
                      <label className={style.footerActive}>Activate Ticker</label>
                      <label className={style.toggleBtn}>
                        <input
                          type="checkbox"
                          checked={selectedItem?.status === "Active"}
                          className={style.inputCheckbox}
                          onChange={(e) =>
                            setSelectedItem({
                              ...selectedItem,
                              status: e.target.checked ? "Active" : "Inactive",
                            })
                          }
                        />
                        <span className={style.slider}></span>
                      </label>
                    </div>
                  </div>

                  <div className={style.buttonSection}>
                    <button
                      // className={style.publishButton}
                      className="buttonCss"
                      onClick={() => {
                        if (selectedItem) {
                          editTicker(selectedItem.srNo);
                          handleUpdateClick();
                        }
                      }}
                    >
                      Update
                    </button>
                    <button
                      // className={style.closeButton}
                      className="closeButtonCss"
                      onClick={() => {
                        handleModalClose();
                        resetTickerData();
                      }}
                    >
                      Close
                    </button>
                  </div>
                </Modal.Body>
              </div>
            </Modal>
          </>
        )}
      </div>
    </div>
  );
};

export default ticker;
